import React, { useMemo } from 'react';
import ServicePanel from "../../../ServicePanel/ServicePanel";
import { getServiceChangeBullets } from "../../../../business-logic/amendmentsLogic";
import { approvalMethodDateModel, serviceModel } from "../../../../models";
import AmendmentChangesInAgreementView from "./AmendmentChangesInAgreementView";
import { Callout, Typography } from 'seagull';
import compact from 'lodash/compact';
function getIntegratedClassName(qboClasses, integratedClassId) {
  if (!qboClasses || !integratedClassId) return null;
  const qboClass = qboClasses.find(_ref => {
    let {
      id
    } = _ref;
    return id === integratedClassId;
  });
  if (!qboClass) return null;
  return qboClass.name;
}
export default function AgreementServiceInstance(props) {
  const {
    service,
    idx,
    agreement,
    agreementData,
    isVendor,
    qboClasses
  } = props;
  const approvalMethod = serviceModel.approvalMethod(service);
  const autoApprovalDate = approvalMethod ? approvalMethodDateModel.autoApprovalDate(approvalMethod) : null;
  const integratedClassId = serviceModel.integratedClassId(service);
  const integratedClassName = getIntegratedClassName(qboClasses, integratedClassId);
  const changeBullets = useMemo(() => {
    return serviceModel.isCompleted(service.status) ? [] : getServiceChangeBullets(service);
  }, [service]);
  return /*#__PURE__*/React.createElement(ServicePanel, {
    service: service,
    idx: idx,
    agreementStatus: agreement.status,
    agreementData: agreementData,
    isVendor: isVendor,
    additionalSections: compact([integratedClassName && {
      disableBorder: true,
      value: /*#__PURE__*/React.createElement(Callout, {
        "data-testid": "service-".concat(idx, "-qbo-class-callout")
      }, "When syncing invoices to QuickBooks Online, the assigned class is set to", ' ', /*#__PURE__*/React.createElement(Typography, {
        as: "span",
        weight: "bold"
      }, integratedClassName), ". This indication is not visible to your client.")
    }]),
    footer: changeBullets.length > 0 && /*#__PURE__*/React.createElement(AmendmentChangesInAgreementView, {
      items: changeBullets,
      autoApprovalDate: autoApprovalDate,
      existingNote: serviceModel.note(service),
      testid: "service-".concat(idx, "-changes")
    })
  });
}